import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=76cbb4c3&"
import script from "./CustomSlider.vue?vue&type=script&lang=js&"
export * from "./CustomSlider.vue?vue&type=script&lang=js&"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports